/** @fileoverview Dashed empty state — prompts class selection or reports no data. */

import { Box, Stack, Text } from '@mantine/core'
import { IconArticleOff } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

type Variant = 'select_class' | 'no_data'

interface DevelopmentReportEmptyStateProps {
  readonly variant: Variant
}

const KEYS: Record<Variant, string> = {
  select_class: 'development_report.empty.select_class',
  no_data: 'development_report.empty.no_data',
}

const CONTAINER_STYLE = {
  border: '1px dashed var(--mantine-color-gray-5, #adb5bd)',
  borderRadius: 12,
}

export function DevelopmentReportEmptyState({ variant }: DevelopmentReportEmptyStateProps) {
  const { t } = useTranslation()

  return (
    <Box p='xl' style={CONTAINER_STYLE}>
      <Stack align='center' spacing={8}>
        <IconArticleOff size={24} color='#868e96' stroke={1.8} />
        <Text color='dimmed' align='center' size='md'>
          {t(KEYS[variant])}
        </Text>
      </Stack>
    </Box>
  )
}
